// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  CustomerTriage,
  CustomerTriageFilter,
  CustomerTriageStatus,
  customerTriageSchema,
} from '@/customer/api/triage-types';
import { z } from 'zod';

const DEFAULT_PAGE_SIZE = 50;

interface ApiResponse {
  data: {
    results: unknown[];
    totalCount: number;
  };
  metadata: { requestId: string };
}

interface TriageCustomersResponse {
  customers: CustomerTriage[];
  totalCount: number;
}

function toApiStatus(status?: CustomerTriageStatus): string | undefined {
  if (!status || status === 'all') {
    return undefined;
  }
  return status;
}

export async function getTriageCustomers(
  filter?: CustomerTriageFilter
): Promise<TriageCustomersResponse> {
  const url = '/v1/customer-triage';
  const response = await api.get<ApiResponse>(url, {
    params: {
      status: toApiStatus(filter?.status),
      page: filter?.page ?? 1,
      limit: filter?.limit ?? DEFAULT_PAGE_SIZE,
    },
  });

  const triageCustomersSchema = z.array(customerTriageSchema);
  const customers = await parseResponse(
    triageCustomersSchema,
    response.data.data.results,
    {
      schemaName: 'TriageCustomers',
      endpoint: url,
    }
  );

  return { customers, totalCount: response.data.data.totalCount };
}
